<template>
  <div :title="title">
    <tvPlayIcon v-if="vod"/>
    <CalendarWithClockIcon v-if="upcoming"/>
    <PodcastIcon v-if="live"/>
  </div>
</template>

<script>
import tvPlayIcon from '../../../assets/img/tvPlayIcon';
import {STREAM_STATUS} from '@/const';
import CalendarWithClockIcon from '../../../assets/img/CalendarWithClockIcon';
import PodcastIcon from '../../../assets/img/PodcastIcon';

export default {
  name: 'EventStatus',
  components: {
    CalendarWithClockIcon,
    tvPlayIcon,
    PodcastIcon,
  },
  props: {
    event: Object,
  },
  computed: {
    live() {
      return STREAM_STATUS.live === this.event.stream_status;
    },
    vod() {
      return STREAM_STATUS.vod === this.event.stream_status;
    },
    upcoming() {
      return STREAM_STATUS.upcoming === this.event.stream_status;
    },
    title() {
      switch (this.event.stream_status) {
        case STREAM_STATUS.live:
          return this.$t('live');
        case STREAM_STATUS.vod:
          return this.$t('vod');
        case STREAM_STATUS.upcoming:
          return this.$t('Coming');
        default:
          return this.$t('Coming');
      }
    },
  },
};
</script>
